import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconComponents: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconComponents"><Path d="M8 6L12 2L16 6L12 10L8 6Z" stroke="currentColor"/><Path d="M2 12L6 8L10 12L6 16L2 12Z" stroke="currentColor"/><Path d="M14 12L18 8L22 12L18 16L14 12Z" stroke="currentColor"/><Path d="M8 18L12 14L16 18L12 22L8 18Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconComponents;
